import { Star } from "lucide-react";
import { Label } from "../ui/label";
import { Input } from "../ui/input";

const Stars = ({ value, onChange, testId }) => (
  <div className="flex gap-1" role="radiogroup" data-testid={testId}>
    {[1, 2, 3, 4, 5].map((n) => (
      <button type="button" key={n} role="radio" aria-checked={value === n} aria-label={`${n} sur 5`} onClick={() => onChange(value === n ? 0 : n)}
        className="grid h-10 w-10 place-items-center rounded-lg hover:bg-slate-100" data-testid={`${testId}-${n}`}>
        <Star className={`h-6 w-6 ${n <= value ? "fill-indigo-400 text-indigo-500" : "text-slate-300"}`} />
      </button>
    ))}
  </div>
);

export const CriteriaBlock = ({ criteria, value, onChange }) => (
  <div className="space-y-2" data-testid="criteria-block">
    <Label className="block">Détaillez votre note (facultatif)</Label>
    <div className="grid gap-2 sm:grid-cols-2">
      {criteria.map((c) => (
        <div key={c.code} className="flex flex-wrap items-center justify-between gap-2 rounded-xl border border-slate-200 px-3 py-2">
          <span className="text-sm text-slate-700">{c.label}</span>
          <Stars value={value[c.code] || 0} onChange={(n) => onChange({ ...value, [c.code]: n })} testId={`criteria-${c.code}`} />
        </div>
      ))}
    </div>
  </div>
);

const Choice = ({ options, value, onChange, testId }) => (
  <div className="flex flex-wrap gap-2" data-testid={testId}>
    {options.map((o) => (
      <button type="button" key={o} onClick={() => onChange(value === o ? "" : o)} data-testid={`${testId}-${o}`}
        className={`rounded-full border px-4 py-2 text-sm ${value === o ? "border-blue-600 bg-blue-600 text-white" : "border-slate-200 bg-white text-slate-700"}`}>{o}</button>
    ))}
  </div>
);

export const QuestionsBlock = ({ questions, value, onChange, errors }) => (
  <div className="space-y-4" data-testid="sector-questions">
    {questions.map((q, i) => {
      const set = (v) => onChange({ ...value, [q.id]: v });
      const tid = `sector-question-${i}`;
      return (
        <div key={q.id}>
          <Label className="mb-1.5 block">{q.label}{q.required ? " *" : ""}</Label>
          {q.type === "text" && <Input maxLength={500} value={value[q.id] || ""} onChange={(e) => set(e.target.value)} data-testid={tid} />}
          {q.type === "choice" && <Choice options={q.options} value={value[q.id]} onChange={set} testId={tid} />}
          {q.type === "yesno" && <Choice options={["oui", "non"]} value={value[q.id]} onChange={set} testId={tid} />}
          {q.type === "rating" && <Stars value={value[q.id] || 0} onChange={set} testId={tid} />}
          {errors?.[q.id] && <p className="mt-1 text-xs text-rose-600">{errors[q.id]}</p>}
        </div>
      );
    })}
  </div>
);

export const SectorAnswers = ({ fb }) => {
  const crit = Object.entries(fb.criteria_ratings || {});
  if (!crit.length && !fb.answers?.length) { return null; }
  return (
    <div className="mt-4 grid gap-3 rounded-xl bg-slate-50 p-4 text-sm sm:grid-cols-2" data-testid="feedback-sector-answers">
      {fb.sector_profile_name && <p className="text-xs text-slate-500 sm:col-span-2">Formulaire « {fb.sector_profile_name} » (version {fb.sector_profile_version})</p>}
      {crit.map(([k, v]) => <p key={k} className="flex justify-between gap-2"><span>{fb.criteria_labels?.[k] || k}</span><b>{v}/5</b></p>)}
      {fb.answers?.map((a) => <p key={a.question_id} className="sm:col-span-2"><span className="text-slate-500">{a.label} :</span> {String(a.value)}</p>)}
    </div>
  );
};
